import { handleApiError } from "../../helpers/errorHandling";
import axiosInstance from "./axiosInstance";

export const AxiosService = {
  // Function to make a GET request
  get: async (url) => {
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Function to make a POST request
  // added sourceParams for axios cancel request integration
  // axiosConfig can include options like responseType: 'blob'
  post: async (url, data, axiosConfig) => {
    try {
      const response = await axiosInstance.post(url, data, axiosConfig);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Function to make a PUT request
  put: async (url, data) => {
    try {
      const response = await axiosInstance.put(url, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },

  // Function to make a DELETE request
  delete: async (url, data) => {
    try {
      const response = await axiosInstance.delete(url, { data: data });
      return response.data;
    } catch (error) {
      throw handleApiError(error);
    }
  },
};
